import { createSelector } from '@ngrx/store';
import { getCvParseState, getCvModuleState } from './index';
import * as fromCvParse from './cv-parse.reducer';


export const selectCvParseState = createSelector(
  getCvModuleState,
  getCvParseState
);

export const selectActiveParsingStatus = createSelector(
  selectCvParseState,
  fromCvParse.getActiveParsingStatus
);

export const selectParsingState = createSelector(
  selectCvParseState,
  fromCvParse.getParsingState
);

export const selectUploadFileStatus = createSelector(
  selectCvParseState,
  fromCvParse.getUploadFileStatus
);

export const selectParsingResultStatus = createSelector(
  selectCvParseState,
  fromCvParse.getParsingResultStatus
);

export const selectCancelParsingStatus = createSelector(
  selectCvParseState,
  fromCvParse.getCancelParsingStatus
);

export const selectRibbonState = createSelector(
  selectCvParseState,
  fromCvParse.getRibbonState
);
